import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { Dialog, withStyles } from "@material-ui/core";
import Clear from "@material-ui/icons/Clear";
import styles from "./HandOver.module.scss";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import DatePicker from "react-datepicker";
import HandOverCompleteConfirmDialog from "./HandOverCompleteConfirmDialog";
import { HANDOVER_DIALOGUES } from "./Constants";
import {
  TRANSLATED_DAYS,
  TRANSLATED_MONTHS,
} from "../../../../common/Constants";

const StyledClear = withStyles({
  root: {
    width: 27,
    height: 27,
    fill: "#102b4e",
    align: "right",
  },
})(Clear);

const StyledDialog = withStyles({
  paper: {
    maxWidth: 607,
    height: 653,
  },
})(Dialog);

class HandOverCompleteCalenderDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      handOverCompleteDate: this.formatTodayDate(),
    };
    this.days = TRANSLATED_DAYS.map((days) => this.props.t(days.label));
    this.months = TRANSLATED_MONTHS.map((months) => this.props.t(months.label));
    this.locale = {
      localize: {
        day: (n) => this.days[n],
        month: (n) => this.months[n],
      },
      formatLong: {},
    };
  }

  handleClose = () => {
    this.props.handleDialogChange(
      null,
      HANDOVER_DIALOGUES.COMPLETE_CALENDER,
      HANDOVER_DIALOGUES.COMPLETE
    );
  };

  handleBack = () => {
    this.props.handleDialogChange(
      HANDOVER_DIALOGUES.COMPLETE,
      HANDOVER_DIALOGUES.COMPLETE_CALENDER
    );
  };

  handleNext = () => {
    this.props.handleDialogChange(
      HANDOVER_DIALOGUES.COMPLETE_CONFIRM,
      HANDOVER_DIALOGUES.COMPLETE_CALENDER
    );
  };

  updateDate = (date) => {
    if (date !== null) {
      this.setState({ handOverCompleteDate: date }); //Set newly selected date
    }
  };

  formatTodayDate = () => {
    if (this.props.todayDate) {
      const dateString = this.props.todayDate;
      const year = dateString.substring(0, 4);
      const month = dateString.substring(5, 7);
      const day = dateString.substring(8, 10);

      return new Date(year, month - 1, day);
    } else return null;
  };

  formatMaxDate = () => {
    const todayDate = this.props.todayDate.split("-");
    return new Date(todayDate[0], todayDate[1] - 1, todayDate[2]);
  };

  render() {
    return (
      <>
        {this.props.open ? (
          <StyledDialog open={this.props.open} onClose={this.handleClose}>
            <div className={styles.dialog}>
              <Grid
                container
                data-testid="handOverCompleteCalenderDialog"
                className={styles.dialogContainer}
                justify="center"
              >
                <Grid item md={12} className={styles.cancel}>
                  <div>
                    <button
                      data-testid="handOverCompleteCalenderCloseDialog"
                      onClick={this.handleClose}
                    >
                      <StyledClear />
                    </button>
                  </div>
                </Grid>

                <Grid item md={9}>
                  <div className={styles.dialogTitle}>
                    {this.props.t("HandOverCompleteCalenderDialog.title")}
                  </div>
                </Grid>

                <Grid item md={9}>
                  <div className={styles.body}>
                    <div className={styles.text}>
                      {this.props.t("HandOverCompleteCalenderDialog.bodyText")}
                    </div>

                    <div
                      className={`${styles.paddingTop} calendarDialogContainer dialogWrapper`}
                    >
                      <DatePicker
                        open={true}
                        locale={this.locale}
                        id="handOverCompleteCalender"
                        selected={this.state.handOverCompleteDate}
                        inline
                        shouldCloseOnSelect={false}
                        maxDate={this.formatMaxDate()}
                        onChange={this.updateDate}
                      />
                    </div>
                  </div>
                </Grid>

                <Grid item md={9}>
                  <div className={styles.dialogActions}>
                    <Button
                      className={styles.cancel}
                      name="handOverCompleteCalenderBack"
                      data-testid="handOverCompleteCalenderBack"
                      onClick={this.handleBack}
                    >
                      {this.props.t("HandOverCompleteCalenderDialog.back")}
                    </Button>
                    <Button
                      className={styles.next}
                      name="handOverCompleteCalenderNext"
                      data-testid="handOverCompleteCalenderNext"
                      onClick={this.handleNext}
                    >
                      {this.props.t("HandOverCompleteCalenderDialog.next")}
                    </Button>
                  </div>
                </Grid>
              </Grid>
            </div>
          </StyledDialog>
        ) : (
          ""
        )}
        <HandOverCompleteConfirmDialog
          {...this.props}
          handOverCompleteDate={this.state.handOverCompleteDate}
          open={this.props.dialogBoxes[HANDOVER_DIALOGUES.COMPLETE_CONFIRM]}
        />
      </>
    );
  }
}

export default withTranslation("emp")(HandOverCompleteCalenderDialog);
